import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import LoadingContainer from '../../components/loading-container';
import Header from '../../components/header';
import OrderSteps from '../../components/order-steps';
import { urlSelector } from '../../selectors/urlSelectors';
import { orderStepSelector } from '../../selectors/orderSelectors';

const OrderContainer = (props) => {
  const { app, currentStep } = props;
  const isFetching = app.isFetching;
  return (
    <LoadingContainer isLoading={isFetching} dispatch={props.dispatch}>
      <Header>Ordina <span>online</span></Header>
      <OrderSteps current={currentStep} />
      {
        React.Children.map(props.children,
          child => React.cloneElement(child, { app, url: props.url })
        )
      }
    </LoadingContainer>
  );
};

OrderContainer.propTypes = {
  currentStep: PropTypes.number,
  dispatch: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
};

const mapStateToProps = (state, props) => ({
  ...state,
  url: urlSelector(state, props),
  currentStep: orderStepSelector(state, props),
});

export default connect(mapStateToProps)(OrderContainer);



// WEBPACK FOOTER //
// ./src/containers/order/order-container.js